<template>
  <div class="calico-billing-item-page">
    <BillingItem
      :amount="10"
      currency="USD"
      date="2026-02-28"
    />

    <BillingItem
      :amount="49"
      currency="USD"
      date="2026-01-15"
    />

    <BillingItem
      :amount="120"
      currency="USD"
      date="2025-12-01"
    />
  </div>
</template>

<script>
import BillingItem from '@/components/calico/billingItem/index.vue'

export default {
  name: 'CalicoBillingItemPage',

  components: {
    BillingItem
  }
}
</script>

<style lang="scss">
.calico-billing-item-page {
  max-width: 600px;
}
</style>